// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class YearlyForecastAgg {
  readonly year: string;
  readonly totalProject: string;
  readonly totalProjectUnit: Enums.Unit;

  constructor(data: { [key: string]: any } = {}) {
    this.year = data.year === undefined ? '' : data.year;
    this.totalProject = data.totalProject === undefined ? '0' : data.totalProject;
    this.totalProjectUnit =
      data.totalProjectUnit === undefined ? Enums.Unit.CuYd : data.totalProjectUnit;
  }

  static zero(): YearlyForecastAgg {
    const zeroValues: ExcludeMethodsDeep<YearlyForecastAgg> = {
      year: '',
      totalProject: '0',
      totalProjectUnit: Enums.Unit.CuYd,
    };
    return new YearlyForecastAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type YearlyForecastAggWireFormat = {
  year: string;
  totalProject: string;
  totalProjectUnit: string;
};

type NewYearlyForecastAggProps = PartialDeep<YearlyForecastAgg, { recurseIntoArrays: true }>;
export const NewYearlyForecastAgg: (props: NewYearlyForecastAggProps) => YearlyForecastAgg = (
  props,
) => new YearlyForecastAgg(props);

type NewYearlyForecastAggFromWireFormatProps = PartialDeep<
  YearlyForecastAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewYearlyForecastAggFromWireFormat: (
  props: NewYearlyForecastAggFromWireFormatProps,
) => YearlyForecastAgg = (props) => new YearlyForecastAgg(props);
